/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackActivity } from './TrackActivity';
import {
    TrackActivityFromJSON,
    TrackActivityFromJSONTyped,
    TrackActivityToJSON,
} from './TrackActivity';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface HistoryResponse
 */
export interface HistoryResponse {
    /**
     * 
     * @type {number}
     * @memberof HistoryResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof HistoryResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof HistoryResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof HistoryResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof HistoryResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<TrackActivity>}
     * @memberof HistoryResponse
     */
    data?: Array<TrackActivity>;
}

/**
 * Check if a given object implements the HistoryResponse interface.
 */
export function instanceOfHistoryResponse(value: object): value is HistoryResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function HistoryResponseFromJSON(json: any): HistoryResponse {
    return HistoryResponseFromJSONTyped(json, false);
}

export function HistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TrackActivityFromJSON)),
    };
}

export function HistoryResponseToJSON(value?: HistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TrackActivityToJSON)),
    };
}

